// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ydgqf","newExpiryDate":"styles_newExpiryDate__m4hl2","footer":"styles_footer__2imwR"};